const NODE_ENV = process.env.NODE_ENV
let baseURL

if (NODE_ENV === 'production') {
    baseURL = 'https://developer-backend.wetax.com.cn'
} else if (NODE_ENV === 'testing') {
    baseURL = 'https://developer-backend-test.wetax.com.cn'
} else {
    // baseURL = '//10.98.2.160:88'
    baseURL = 'https://developer-backend-test.wetax.com.cn'
}

module.exports = baseURL
